// @ts-nocheck
/* eslint-disable */
export const boldDoubleArrowDownIcon = {
    data: ``,
    name: 'bold-double-arrow-down' as const
};